import termsOfServiceMarkdown from '../content/legal/terms-of-service.md';
import { parseMarkdownWithFrontmatter } from './markdownLoader';

// This will store the current TOS version
let currentVersion: string | null = null;

/**
 * Gets the current Terms of Service version from the markdown file
 * @returns The current TOS version
 */
export function getCurrentTOSVersion(): string {
  // Check for environment variable first (for development)
  if (process.env.REACT_APP_TOS_VERSION) {
    return process.env.REACT_APP_TOS_VERSION;
  }

  // If we already have the version, return it
  if (currentVersion) {
    return currentVersion;
  }

  try {
    // Parse the markdown that was loaded by raw-loader
    const { metadata } = parseMarkdownWithFrontmatter(termsOfServiceMarkdown);
    
    // Store and return the version
    currentVersion = metadata.version || '2025-06-05'; // Default fallback
    return currentVersion;
  } catch (error) {
    console.error('Error loading TOS version:', error);
    // Return default version on error
    currentVersion = '2025-06-05';
    return currentVersion;
  }
}

/**
 * Async version for backward compatibility
 * @returns Promise that resolves to the current TOS version
 */
export async function getCurrentTOSVersionAsync(): Promise<string> {
  return getCurrentTOSVersion();
}

// For backward compatibility, export a default version
// This will be replaced by the actual version once loaded
export const CURRENT_TOS_VERSION_DEFAULT = '2025-06-05';